import { Gallerie } from "@/src/data/types";
import { useEffect, useState } from "react";
import { getAllGalleries } from "../../../../../API/Mediatheque/Gallerie/gallerieService";
import BreadCrumb from "../../../../../components/breadcrumb";
import Header from "../../../../../components/DashboardNavigation/header";
import Sidebar from "../../../../../components/DashboardNavigation/sidebar";
import { GallerieData } from "../../../../../components/tables/galleries-tables/gallerie";

const breadcrumbItems = [
  { title: "Photos", link: "/admin-dashboard/mediatheque/photos" },
];
export default function Galleries() {
  const [galleries, setGalleries] = useState<Gallerie[]>([]);
  const fetchData = async () => {
    const response = await getAllGalleries();
    setGalleries(response?.galleries);
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <Header />
      <div className="flex h-screen overflow-hidden">
        <Sidebar />
        <div className="flex-1 p-4 pt-6 space-y-4 md:p-8">
          <BreadCrumb items={breadcrumbItems} />
          <GallerieData data={galleries} />
        </div>
      </div>
    </>
  );
}
